import { useNavigate } from "react-router-dom";

import Icon from "@/components/Icon";
import { CreditGroup } from "@/types/credit-groups";
import { creditExpirationText, formatDate } from "@/utils/credit-groups";

import { CardShell } from "../Common";

type Props = {
  item: CreditGroup;
};

export default function CreditGroupCard({ item }: Props) {
  const navigate = useNavigate();

  const handleBook = () =>
    navigate(`/book?store=${encodeURIComponent(item.store_code)}`);

  return (
    <CardShell>
      {/* Header */}
      <div className="flex justify-between gap-7 p-4">
        <div className="flex items-start gap-3">
          <div className="flex size-14 items-center justify-center rounded-md bg-[#e6f0f9] font-poppins text-3xl font-semibold text-amalfi-coast">
            {item.credits_remaining}
          </div>
          <div className="flex flex-col items-start gap-1">
            <span className="font-poppins text-sm font-semibold leading-[14px] text-deep-blue">
              {item.group_service_name}
            </span>
            <span className="font-poppins text-xs text-[#9ca3af]">
              {item.store_description}
            </span>
          </div>
        </div>
        <button type="button" onClick={handleBook} className="cursor-pointer">
          <Icon name="calendar-plus" />
        </button>
      </div>

      {/* Details */}
      <div className="border-t border-[#d1d5db] bg-[#f9fbfe] p-4 font-poppins text-sm leading-[140%] text-neutral-dark">
        <CreditGroupStatus item={item} />
      </div>
    </CardShell>
  );
}

const CreditGroupStatus = ({ item }: Props) => {
  if (item.status === "FROZEN") {
    const showFreeze =
      item.are_all_credits_frozen && !!item.freeze_expiration_datetime;

    if (!showFreeze) return <div className="text-[#6b7280]">Frozen</div>;

    return (
      <div className="text-[#6b7280]">
        Unfreezes on{" "}
        <strong>{formatDate(item.freeze_expiration_datetime)!}</strong>
      </div>
    );
  }

  if (item.status === "ACTIVE_IN_FUTURE") {
    return <div className="text-[#6b7280]">Coming soon!</div>;
  }

  return (
    <>
      {!!item.credits_remaining && (
        <div>
          {creditExpirationText(
            item.next_expiration_credits,
            item.next_expiration_datetime,
            item.type,
          )}
        </div>
      )}
      {!item.is_universal && (
        <div className="text-xs text-[#6b7280]">
          Usable at {item.store_description}
        </div>
      )}
    </>
  );
};
